/**
 * SkipLink - Accessibility skip navigation link
 * Allows keyboard users to skip to main content
 */

import { FC } from 'react';
import { Box, Link } from '@mui/material';

export interface SkipLinkProps {
  targetId?: string;
  children?: string;
}

export const SkipLink: FC<SkipLinkProps> = ({
  targetId = 'main-content',
  children = 'Skip to main content',
}) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const target = document.getElementById(targetId);
    if (target) {
      target.focus();
      target.scrollIntoView();
    }
  };

  return (
    <Box
      component={Link}
      href={`#${targetId}`}
      onClick={handleClick}
      sx={{
        position: 'absolute',
        left: '-9999px',
        zIndex: 9999,
        padding: 2,
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        textDecoration: 'none',
        fontWeight: 600,
        borderRadius: 1,
        '&:focus': {
          left: 8,
          top: 8,
          outline: '2px solid',
          outlineColor: 'primary.dark',
          outlineOffset: 2,
        },
      }}
      aria-label={children}
    >
      {children}
    </Box>
  );
};
